export const SET_MENU_DISPLAY = 'SET_MENU_DISPLAY'

export const SET_EVENT_NOTIFICATION_DETAILS = 'SET_EVENT_NOTIFICATION_DETAILS'


export const SET_COUNTRY_DIALOG ="SET_COUNTRY_DIALOG"